import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '#/modules/commonComponents/tooltip';

/**
 * 物料顯示：上名稱、下料號（mono）；hover Tooltip 顯示完整名稱＋編號。
 * 可選 detailPath：雙擊新分頁開啟（例 ROUTES.mtrDetail(id)）。
 * 單據 list／選料左列／工單替代料共用。
 */
const MaterialNameStack = ({
  name,
  code,
  className,
  detailPath = null,
}) => {
  const displayName = name || code || '-';
  const displayCode = code || '-';
  const canNavigate = Boolean(detailPath);

  function handleNavigate() {
    if (!canNavigate) {
      return;
    }
    window.open(detailPath, '_blank', 'noopener,noreferrer');
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          role={canNavigate ? 'link' : undefined}
          tabIndex={canNavigate ? 0 : undefined}
          className={cn(
            'inline-block w-fit max-w-full min-w-0',
            canNavigate && 'cursor-pointer',
            className,
          )}
          onDoubleClick={canNavigate ? handleNavigate : undefined}
          onKeyDown={canNavigate ? (event) => {
            if (event.key === 'Enter') {
              handleNavigate();
            }
          } : undefined}
        >
          <p
            className={cn(
              'truncate text-sm font-medium',
              canNavigate ? 'text-primary-600 hover:underline' : 'text-gray-900',
            )}
          >
            {displayName}
          </p>
          <p className="truncate font-mono text-xs text-gray-500">
            {displayCode}
          </p>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs flex-col items-start gap-0.5">
        <p className="text-sm font-medium">{displayName}</p>
        <p className="font-mono text-xs opacity-90">{displayCode}</p>
        {canNavigate ? (
          <p className="mt-0.5 text-xs opacity-80">雙擊開啟物料（新分頁）</p>
        ) : null}
      </TooltipContent>
    </Tooltip>
  );
};

MaterialNameStack.propTypes = {
  name: PropTypes.string,
  code: PropTypes.string,
  className: PropTypes.string,
  detailPath: PropTypes.string,
};

export default MaterialNameStack;
